export const getDataProduct = (order, productId) => {
  const { product } = order.items.find(
    elem => elem.product && elem.product.id === productId
  )
  return product
}
